/* eslint-disable import/prefer-default-export */

import bridge from '@/utils/bridge';

export function getDeviceInfo() {
  return bridge.ask('HydraServer', 'getDeviceInfo');
}
